import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { VitalPlate, VitalPlateData } from '../plate';
import { useSessionRoomState } from '../../../../context';

const INCHES_PER_FOOT = 12;

const formatHeight = (
  value: number,
  unit: string
): { value: string | number; units: string } => {
  const normalizedUnit = unit.trim().toLowerCase();

  if (normalizedUnit === 'in' || normalizedUnit === 'inch' || normalizedUnit === 'inches') {
    const totalInches = Math.round(value);
    const feet = Math.floor(totalInches / INCHES_PER_FOOT);
    const inches = totalInches % INCHES_PER_FOOT;

    return { value: `${feet}' ${inches}"`, units: '' };
  }

  return { value, units: unit };
};

export const VitalManualHeight: FC = () => {
  const { t } = useTranslation(['session-room']);
  const { vitalsData } = useSessionRoomState();
  const [value, units] = useMemo(() => {
    const height = vitalsData.manualHeight;
    if (!height?.Value) {
      return ['-', ''];
    }

    const formatted = formatHeight(height.Value, height.Unit || 'in');
    return [formatted.value, formatted.units];
  }, [vitalsData.manualHeight]);

  return (
    <VitalPlate>
      <VitalPlateData
        title={t('session-room:SENSORS.HEIGHT')}
        units={units}
        color="#7bffb5"
        value={value}
      />
    </VitalPlate>
  );
};
